import {Observable, of} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

export class VermittlerResponse {
  vermittlerName: string;
  beratungsprotokoll: string;
  nummer: string;
};

@Injectable()
export class AudisService {

  constructor(private http: HttpClient){}

  getVermittler(host: string, vermittlernummer: string): Observable<VermittlerResponse> {
    return this.http.get<VermittlerResponse>(`${host}/api/process/vermittler/${vermittlernummer}`).pipe(
        catchError(_ => of(new VermittlerResponse()))
    );
  }

}
